import type { ComparisonConfig } from './ComparisonPage';

const HOTELOGIX_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-hotelogix',
  competitorName: 'Hotelogix',
  heroTitle: 'HotelStack.io مقابل Hotelogix',
  heroSubtitle: 'مقارنة شاملة بين منصتين رائدتين لإدارة الفنادق. اكتشف كيف يقدم HotelStack.io ميزات أكثر وبنية حديثة وقيمة أفضل من Hotelogix.',
  overviewComparison: [
    { label: 'إجمالي الوحدات', hotelstack: '36 وحدة متكاملة', competitor: '15 وحدة' },
    { label: 'البنية التقنية', hotelstack: 'SaaS سحابي أصلي', competitor: 'سحابة تقليدية' },
    { label: 'الانتشار العالمي', hotelstack: 'أكثر من 40 دولة', competitor: 'آسيا بشكل رئيسي' },
    { label: 'مدير القنوات', hotelstack: 'مدمج (أكثر من 100 OTA)', competitor: 'إضافة مدفوعة' },
    { label: 'محرك الحجز', hotelstack: 'BookMyRoom.io (مجاني)', competitor: 'أداة بسيطة' },
    { label: 'الدعم الفني', hotelstack: 'دعم مخصص على مدار الساعة', competitor: 'بريد إلكتروني + دردشة' },
  ],
  featureTable: [
    {
      category: 'نظام إدارة الفندق الأساسي',
      features: [
        { name: 'لوحة الغرف المرئية', hotelstack: true, competitor: true },
        { name: 'تسجيل الوصول بالسحب والإفلات', hotelstack: true, competitor: false },
        { name: 'معالج التدقيق الليلي', hotelstack: true, competitor: true },
        { name: 'إدارة حساب النزيل', hotelstack: true, competitor: true },
        { name: 'بوابة تسجيل الوصول عبر الإنترنت', hotelstack: true, competitor: false },
        { name: 'نافذة حجز الزائرين المباشرين', hotelstack: true, competitor: 'محدود' },
      ],
    },
    {
      category: 'إدارة الإيرادات',
      features: [
        { name: 'قواعد التسعير الديناميكي', hotelstack: true, competitor: false },
        { name: 'محاكي الإيرادات الافتراضي', hotelstack: true, competitor: false },
        { name: 'مراقبة أسعار المنافسين', hotelstack: true, competitor: false },
        { name: 'التنبؤ بالطلب', hotelstack: true, competitor: false },
        { name: 'تحليلات RevPAR', hotelstack: true, competitor: 'أساسي' },
      ],
    },
    {
      category: 'إدارة النزلاء',
      features: [
        { name: 'ملفات النزلاء الشاملة 360 درجة', hotelstack: true, competitor: 'أساسي' },
        { name: 'إدارة برنامج الولاء', hotelstack: true, competitor: false },
        { name: 'أتمتة التواصل مع النزلاء', hotelstack: true, competitor: 'محدود' },
        { name: 'تحليلات إنفاق النزلاء', hotelstack: true, competitor: false },
        { name: 'رفع الهوية والتقاط الصور', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'الأغذية والمشروبات ونقاط البيع',
      features: [
        { name: 'محطة نقاط البيع POS', hotelstack: true, competitor: false },
        { name: 'مخطط طاولات المطعم', hotelstack: true, competitor: false },
        { name: 'نظام عرض المطبخ', hotelstack: true, competitor: false },
        { name: 'وحدة خدمة الغرف', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'التقارير والتحليلات',
      features: [
        { name: 'التقرير السريع', hotelstack: true, competitor: true },
        { name: 'بيان الأرباح والخسائر P&L', hotelstack: true, competitor: false },
        { name: 'تقرير الوتيرة', hotelstack: true, competitor: false },
        { name: 'تقارير الامتثال الضريبي', hotelstack: true, competitor: 'أساسي' },
        { name: 'منشئ التقارير المخصصة', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'إدارة العقارات المتعددة',
      features: [
        { name: 'لوحة تحكم السلسلة', hotelstack: true, competitor: true },
        { name: 'تحليلات عبر العقارات', hotelstack: true, competitor: false },
        { name: 'إدارة الأسعار المركزية', hotelstack: true, competitor: false },
        { name: 'إعدادات العلامة التجارية', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'المرونة والعمل دون اتصال',
      features: [
        { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
        { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
        { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
        { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
        { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'مبيعات الشركات والمجموعات',
      features: [
        { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: false },
        { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: 'إضافة مدفوعة' },
        { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: false },
        { name: 'حجوزات المطاعم', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'الموظفون والموارد البشرية',
      features: [
        { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: false },
        { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
        { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
        { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$60+',
    hotelstackNote: 'جميع الوحدات الـ 36 مضمنة. بدون قيود على الميزات. إعداد مجاني وترحيل بيانات مجاني. تسعير إقليمي بعملات EUR، GBP، AED، INR، THB.',
    competitorNote: 'خطة أساسية بوحدات محدودة. مدير القنوات والميزات المتقدمة تتطلب رسومًا إضافية.',
  },
  advantages: [
    'أكثر من ضعف عدد الوحدات (36 مقابل 15) بدون رسوم إضافية للميزات الأساسية',
    'بنية سحابية أصلية حديثة تم إنشاؤها عام 2024 مع مزامنة فورية عبر جميع الأجهزة',
    'دعم متعدد العملات مع تسعير إقليمي بـ 6 عملات وأدوات امتثال لأكثر من 40 دولة',
    'محرك حجز مدمج عبر BookMyRoom.io — حجوزات مباشرة بدون عمولة مضمنة',
    'إدارة إيرادات متقدمة مع تسعير ديناميكي وتنبؤ بالطلب ومحاكيات افتراضية',
    'وحدة أغذية ومشروبات ونقاط بيع كاملة مع إدارة الطاولات وعرض المطبخ وخدمة الغرف',
    'سعر بداية أقل مع ميزات أكثر مضمنة في الخطة الأساسية',
    'ترحيل بيانات مجاني من Hotelogix مع دعم إعداد مخصص',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'HotelStack.io هو الخيار الأقوى للفنادق التي تبحث عن منصة حديثة متكاملة. مع 36 وحدة وإدارة إيرادات مدمجة وقدرات أغذية ومشروبات وأسعار أقل، يقدم قيمة أكبر بكثير من Hotelogix. قد يناسب Hotelogix الفنادق ذات الميزانية المحدودة التي تحتاج فقط إلى وظائف PMS الأساسية.',
    bestFor: [
      'الفنادق التي تريد منصة حديثة متكاملة بدون رسوم إضافية',
      'العقارات التي تحتاج إلى إدارة إيرادات متقدمة وتسعير ديناميكي',
      'الفنادق التي تتطلب قدرات أغذية ومشروبات ونقاط بيع وخدمة غرف',
      'العقارات التي تحتاج إلى امتثال إقليمي وفوترة متعددة العملات',
      'سلاسل الفنادق المتعددة التي تحتاج إلى تحليلات مركزية وإدارة أسعار موحدة',
    ],
  },
  faqItems: [
    { question: 'هل يمكنني الانتقال من Hotelogix إلى HotelStack.io؟', answer: 'نعم. يتولى فريقنا ترحيل البيانات بالكامل من Hotelogix بما في ذلك ملفات النزلاء وسجل الحجوزات وخطط الأسعار وتكوينات الغرف. الترحيل مجاني ويكتمل عادةً خلال 48 ساعة بدون أي توقف.' },
    { question: 'هل يحتوي HotelStack.io على جميع ميزات Hotelogix؟', answer: 'يتضمن HotelStack.io كل ميزة يقدمها Hotelogix بالإضافة إلى 17 وحدة إضافية تشمل إدارة الإيرادات والأغذية والمشروبات/نقاط البيع وبرامج الولاء وأدوات الامتثال والتحليلات المتقدمة التي لا يوفرها Hotelogix.' },
    { question: 'كيف تتم مقارنة الأسعار بين HotelStack.io و Hotelogix؟', answer: 'يبدأ HotelStack.io من $49 شهريًا مع تضمين جميع الوحدات الـ 36. تسعير إقليمي متاح بعملات EUR، GBP، AED، INR، و THB. يبدأ Hotelogix من حوالي $60+ شهريًا للخطة الأساسية، مع رسوم إضافية لمدير القنوات وميزات أخرى.' },
    { question: 'هل HotelStack.io مناسب للفنادق الصغيرة التي تستخدم حاليًا Hotelogix؟', answer: 'بالتأكيد. تم تصميم خطتنا المبدئية للعقارات التي تصل إلى 50 غرفة مع فتح جميع الميزات. العديد من الفنادق الصغيرة تنتقل من Hotelogix للحصول على وحدات إضافية وسعر أقل.' },
  ],
};

const CLOUDBEDS_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-cloudbeds',
  competitorName: 'Cloudbeds',
  heroTitle: 'HotelStack.io مقابل Cloudbeds',
  heroSubtitle: 'كلاهما منصتان سحابيتان أصليتان. يقدم HotelStack.io وحدات أكثر وأسعارًا أقل وقدرات أغذية ومشروبات/نقاط بيع كاملة يفتقر إليها Cloudbeds — مع تسعير إقليمي متعدد العملات.',
  overviewComparison: [
    { label: 'إجمالي الوحدات', hotelstack: '36 وحدة', competitor: 'أكثر من 20 وحدة' },
    { label: 'التسعير', hotelstack: 'من $49 شهريًا', competitor: 'من $100+ شهريًا' },
    { label: 'التسعير الإقليمي', hotelstack: '6 عملات', competitor: 'USD فقط' },
    { label: 'الأغذية والمشروبات / POS', hotelstack: 'مدمج', competitor: 'غير متوفر' },
    { label: 'محرك الحجز', hotelstack: 'BookMyRoom.io (مجاني)', competitor: 'أداة بسيطة' },
    { label: 'الإعداد', hotelstack: 'مجاني + مخصص', competitor: 'خدمة ذاتية' },
  ],
  featureTable: [
    {
      category: 'نظام إدارة الفندق الأساسي',
      features: [
        { name: 'لوحة الغرف المرئية', hotelstack: true, competitor: true },
        { name: 'إدارة الحجوزات', hotelstack: true, competitor: true },
        { name: 'الحجوزات الجماعية', hotelstack: true, competitor: true },
        { name: 'معالج التدقيق الليلي', hotelstack: true, competitor: true },
        { name: 'بوابة تسجيل الوصول عبر الإنترنت', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'الامتثال الإقليمي',
      features: [
        { name: 'الفوترة متعددة العملات', hotelstack: true, competitor: 'محدود' },
        { name: 'أتمتة الضرائب الإقليمية', hotelstack: true, competitor: false },
        { name: 'امتثال تسجيل النزلاء', hotelstack: true, competitor: false },
        { name: 'حماية بيانات GDPR', hotelstack: true, competitor: true },
        { name: 'بوابات الدفع الإقليمية', hotelstack: true, competitor: 'محدود' },
        { name: 'الفوترة المحلية', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'إدارة الإيرادات',
      features: [
        { name: 'التسعير الديناميكي', hotelstack: true, competitor: true },
        { name: 'تحليلات الإيرادات', hotelstack: true, competitor: true },
        { name: 'مراقبة أسعار المنافسين', hotelstack: true, competitor: 'إضافة مدفوعة' },
        { name: 'المحاكي الافتراضي', hotelstack: true, competitor: false },
        { name: 'التنبؤ بالطلب', hotelstack: true, competitor: 'أساسي' },
      ],
    },
    {
      category: 'الأغذية والمشروبات والعمليات',
      features: [
        { name: 'محطة نقاط البيع POS', hotelstack: true, competitor: false },
        { name: 'وحدة خدمة الغرف', hotelstack: true, competitor: false },
        { name: 'لوحة التدبير المنزلي', hotelstack: true, competitor: true },
        { name: 'أوامر عمل الصيانة', hotelstack: true, competitor: false },
        { name: 'جدولة الموظفين', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'الامتثال والتقارير',
      features: [
        { name: 'تقارير الضرائب الإقليمية', hotelstack: true, competitor: false },
        { name: 'سجل التدقيق', hotelstack: true, competitor: true },
        { name: 'بيان الأرباح والخسائر P&L', hotelstack: true, competitor: 'محدود' },
        { name: 'منشئ التقارير المخصصة', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'المرونة والعمل دون اتصال',
      features: [
        { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
        { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
        { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
        { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
        { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'مبيعات الشركات والمجموعات',
      features: [
        { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: false },
        { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: 'محدود' },
        { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: false },
        { name: 'حجوزات المطاعم', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'الموظفون والموارد البشرية',
      features: [
        { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: 'إضافة مدفوعة' },
        { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
        { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
        { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'جميع الوحدات الـ 36 مضمنة. تسعير إقليمي بعملات EUR، GBP، AED، INR، THB. إعداد وترحيل مجاني.',
    competitorNote: 'تسعير بـ USD فقط ($100+ شهريًا). رسوم إضافية للميزات المتقدمة والتكاملات.',
  },
  advantages: [
    'جميع الوحدات الـ 36 مضمنة بنصف التكلفة تقريبًا — بدون رسوم إضافية للميزات الأساسية',
    'تسعير إقليمي بـ 6 عملات — بدون مفاجآت أسعار الصرف للعقارات الدولية',
    'وحدة أغذية ومشروبات كاملة مع محطة نقاط بيع وخدمة غرف وإدارة مطبخ',
    'أدوات امتثال إقليمية لأتمتة الضرائب وتسجيل النزلاء و GDPR',
    'دعم بوابات دفع متعددة عبر PaymentHooks.com (Stripe، PayPal، أكثر من 50 بوابة) للطرق العالمية والمحلية',
    'وحدة إدارة الموظفين مع الرواتب والحضور وجدولة المناوبات',
    'إدارة الصيانة وأوامر العمل مع تتبع الأصول',
    'إعداد مجاني وترحيل بيانات مع فريق دعم مخصص',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'يقدم HotelStack.io وحدات أكثر وقيمة أفضل وأدوات تشغيلية كاملة بنصف سعر Cloudbeds تقريبًا. بينما يعد Cloudbeds منصة قوية لنظام PMS الأساسي وإدارة القنوات، يضيف HotelStack.io الأغذية والمشروبات/POS وإدارة الموظفين والصيانة وأدوات إيرادات متقدمة — جميعها مضمنة في السعر الأساسي.',
    bestFor: [
      'الفنادق التي تريد منصة متكاملة شاملة بسعر أقل',
      'العقارات التي تحتاج إلى أغذية ومشروبات ونقاط بيع وإدارة موظفين في نظام واحد',
      'الفنادق التي تريد امتثالًا إقليميًا وفوترة متعددة العملات',
      'العقارات التي تفضل إعدادًا مخصصًا بدلاً من الإعداد الذاتي',
      'سلاسل الفنادق المتعددة التي تحتاج إلى تحليلات مركزية وإدارة أسعار موحدة',
    ],
  },
  faqItems: [
    { question: 'هل يمكنني الانتقال من Cloudbeds إلى HotelStack.io؟', answer: 'نعم. يتولى فريق الإعداد لدينا ترحيل البيانات بالكامل من Cloudbeds بما في ذلك ملفات النزلاء وسجل الحجوزات وخطط الأسعار. الترحيل مجاني ويكتمل عادةً خلال 48 ساعة.' },
    { question: 'هل يدعم HotelStack.io نفس قنوات OTA التي يدعمها Cloudbeds؟', answer: 'نعم. يتصل HotelStack.io بأكثر من 100 OTA بما في ذلك Booking.com و Expedia و Airbnb و Agoda والمنصات الإقليمية. يتوفر أيضًا اتصال GDS عبر Amadeus و Sabre.' },
    { question: 'لماذا HotelStack.io أقل تكلفة من Cloudbeds؟', answer: 'يتضمن HotelStack.io جميع الوحدات الـ 36 في كل خطة بدون رسوم إضافية. التسعير الإقليمي بـ 6 عملات يقلل التكاليف أكثر. يفرض Cloudbeds رسومًا إضافية للميزات المتقدمة ويقدم تسعيرًا بـ USD فقط.' },
    { question: 'هل يعمل HotelStack.io للعقارات الدولية؟', answer: 'بالتأكيد. يدعم HotelStack.io الفوترة متعددة العملات والامتثال الضريبي الإقليمي وبوابات الدفع الدولية. تستخدم فنادق في أكثر من 40 دولة HotelStack.io لإدارة عملياتها.' },
  ],
};

const MEWS_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-mews',
  competitorName: 'Mews',
  heroTitle: 'HotelStack.io مقابل Mews',
  heroSubtitle: 'يستهدف Mews فنادق المؤسسات بأسعار مرتفعة وتنفيذ مدفوع. يقدم HotelStack.io نفس التجربة الحديثة مع وحدات أكثر بجزء بسيط من التكلفة — مع إعداد مجاني.',
  overviewComparison: [
    { label: 'شريحة الفنادق', hotelstack: 'من الصغيرة إلى المؤسسات', competitor: 'المؤسسات فقط' },
    { label: 'التسعير', hotelstack: 'من $49 شهريًا', competitor: '$200+ شهريًا' },
    { label: 'إجمالي الوحدات', hotelstack: '36 وحدة مدمجة', competitor: 'أكثر من 15 وحدة أساسية' },
    { label: 'الأغذية والمشروبات / POS', hotelstack: 'مدمج', competitor: 'عبر التكامل' },
    { label: 'جودة واجهة المستخدم', hotelstack: 'تصميم فاخر داكن حديث', competitor: 'تصميم بسيط حديث' },
    { label: 'الإعداد', hotelstack: 'مجاني + مخصص', competitor: 'تنفيذ مدفوع' },
  ],
  featureTable: [
    {
      category: 'نظام إدارة الفندق الأساسي',
      features: [
        { name: 'بنية سحابية أصلية', hotelstack: true, competitor: true },
        { name: 'واجهة مستخدم حديثة', hotelstack: true, competitor: true },
        { name: 'مزامنة فورية', hotelstack: true, competitor: true },
        { name: 'وصول متعدد الأجهزة', hotelstack: true, competitor: true },
        { name: 'أتمتة التدقيق الليلي', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'الامتثال الإقليمي',
      features: [
        { name: 'الفوترة متعددة العملات', hotelstack: true, competitor: true },
        { name: 'أتمتة الضرائب الإقليمية', hotelstack: true, competitor: 'الاتحاد الأوروبي فقط' },
        { name: 'امتثال تسجيل النزلاء', hotelstack: true, competitor: 'الاتحاد الأوروبي فقط' },
        { name: 'حماية بيانات GDPR', hotelstack: true, competitor: true },
        { name: 'بوابات الدفع الإقليمية', hotelstack: true, competitor: 'محدود' },
        { name: 'تسعير إقليمي (6 عملات)', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'الإيرادات والتوزيع',
      features: [
        { name: 'مدير القنوات', hotelstack: true, competitor: true },
        { name: 'التسعير الديناميكي', hotelstack: true, competitor: true },
        { name: 'محرك الحجز', hotelstack: true, competitor: true },
        { name: 'تحليلات الإيرادات', hotelstack: true, competitor: true },
        { name: 'المحاكي الافتراضي', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'العمليات',
      features: [
        { name: 'إدارة التدبير المنزلي', hotelstack: true, competitor: true },
        { name: 'وحدة POS / الأغذية والمشروبات', hotelstack: true, competitor: 'عبر التكامل' },
        { name: 'جدولة الموظفين', hotelstack: true, competitor: false },
        { name: 'الصيانة / أوامر العمل', hotelstack: true, competitor: false },
        { name: 'التواصل مع النزلاء', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'التسعير والدعم',
      features: [
        { name: 'إعداد مجاني', hotelstack: true, competitor: false },
        { name: 'ترحيل بيانات مجاني', hotelstack: true, competitor: false },
        { name: 'دعم على مدار الساعة', hotelstack: true, competitor: 'ساعات العمل' },
        { name: 'بدون رسوم تنفيذ', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'المرونة والعمل دون اتصال',
      features: [
        { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
        { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
        { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
        { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
        { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'مبيعات الشركات والمجموعات',
      features: [
        { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: 'إضافة مدفوعة' },
        { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: true },
        { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: 'إضافة مدفوعة' },
        { name: 'حجوزات المطاعم', hotelstack: true, competitor: 'عبر التكامل' },
      ],
    },
    {
      category: 'الموظفون والموارد البشرية',
      features: [
        { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: 'عبر التكامل' },
        { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
        { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
        { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$200+',
    hotelstackNote: 'جميع الوحدات الـ 36 مضمنة. إعداد وترحيل مجاني. تسعير إقليمي بـ 6 عملات.',
    competitorNote: 'تسعير مؤسسات ($200+ شهريًا). تنفيذ وإعداد مدفوع. الدعم المتقدم برسوم إضافية.',
  },
  advantages: [
    'سعر بداية أقل بنسبة 75% تقريبًا مع وحدات أكثر مضمنة في كل خطة',
    'إعداد مجاني وترحيل بيانات مقابل تنفيذ مدفوع في Mews',
    'أغذية ومشروبات ونقاط بيع مدمجة بالكامل مقابل الحاجة لتكامل طرف ثالث مع Mews',
    'تسعير إقليمي بـ 6 عملات — تدفع الفنادق بعملتها المحلية',
    'إدارة الموظفين والرواتب وجدولة المناوبات مضمنة',
    'إدارة الصيانة وأوامر العمل مدمجة في المنصة',
    'دعم مخصص على مدار الساعة مقابل دعم ساعات العمل في Mews',
    'متاح للفنادق الصغيرة والمتوسطة وليس فقط المؤسسات — جميع الخطط تتضمن جميع الوحدات',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'يعد Mews منصة ممتازة لفنادق المؤسسات المستعدة لدفع أسعار مرتفعة. يضاهي HotelStack.io منصة Mews في تجربة المستخدم الحديثة والبنية السحابية مع إضافة الأغذية والمشروبات/POS وإدارة الموظفين ووحدات الصيانة — بربع السعر تقريبًا مع إعداد مجاني.',
    bestFor: [
      'الفنادق التي تريد جودة تجربة مستخدم مماثلة لـ Mews بسعر أكثر سهولة',
      'العقارات التي تحتاج إلى أغذية ومشروبات ونقاط بيع وأدوات تشغيلية مدمجة',
      'الفنادق التي تريد إعدادًا مجانيًا بدون رسوم تنفيذ',
      'الفنادق الصغيرة والمتوسطة التي تتجاوز ميزانيتها خطط Mews المؤسسية',
      'سلاسل الفنادق المتعددة التي تحتاج إلى إدارة مركزية مع امتثال إقليمي',
    ],
  },
  faqItems: [
    { question: 'كيف يقارن HotelStack.io مع Mews من حيث جودة واجهة المستخدم؟', answer: 'تقدم كلتا المنصتين واجهات حديثة وسهلة الاستخدام. يتميز HotelStack.io بتصميم فاخر داكن مصمم خصيصًا لقطاع الضيافة، مع 36 وحدة متكاملة يمكن الوصول إليها من لوحة تحكم واحدة. يتميز Mews بتصميم بسيط ونظيف يركز على سير العمل الأوروبي.' },
    { question: 'هل يتضمن Mews قدرات أغذية ومشروبات ونقاط بيع؟', answer: 'يتطلب Mews تكاملات طرف ثالث للأغذية والمشروبات ونقاط البيع. يتضمن HotelStack.io محطة نقاط بيع كاملة ووحدة خدمة غرف ونظام عرض مطبخ وإدارة مطاعم كميزات قياسية في كل خطة.' },
    { question: 'هل يمكنني الحصول على نفس التجربة الحديثة التي يقدمها Mews بسعر أقل؟', answer: 'نعم. يقدم HotelStack.io تجربة سحابية أصلية حديثة مع مزامنة فورية وواجهة جميلة و 36 وحدة بسعر $49 شهريًا مقابل $200+ شهريًا لـ Mews. بالإضافة إلى أن الإعداد والترحيل مجانيان.' },
    { question: 'هل يقدم HotelStack.io تكاملات API مثل Mews؟', answer: 'نعم. يوفر HotelStack.io سوق تكاملات مع واجهات API لبوابات الدفع و OTA وبرامج المحاسبة وخدمات الطرف الثالث. تدعم بنيتنا القائمة على API التكاملات المخصصة لمتطلبات المؤسسات.' },
  ],
};

export const COMPARISON_AR: Record<string, ComparisonConfig> = {
  'hotelstack-vs-hotelogix': HOTELOGIX_AR,
  'hotelstack-vs-cloudbeds': CLOUDBEDS_AR,
  'hotelstack-vs-mews': MEWS_AR,
};
